// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetApiSearchAutocompleteData, GetApiSearchAutocompleteResponse, GetApiSearchListingAutocompleteData, GetApiSearchListingAutocompleteResponse } from './types.gen';

/**
 * Retrieve a list of address locations
 * Returns an array of address locations that are the best fit to autocomplete
 * @param data The data for the request.
 * @param data.typedAddress
 * @param data.locality locality id
 * @returns Autocomplete Successful retrieval of address locations
 * @throws ApiError
 */
export const getApiSearchAutocomplete = (data: GetApiSearchAutocompleteData): CancelablePromise<GetApiSearchAutocompleteResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/search/autocomplete',
        query: {
            typed_address: data.typedAddress,
            locality: data.locality
        }
    });
};

/**
 * Retrieve a list of autocomplete listings
 * Returns an array of autocomplete listings based on the search query
 * @param data The data for the request.
 * @param data.query
 * @returns AutocompleteListing Successful retrieval of autocomplete listings
 * @throws ApiError
 */
export const getApiSearchListingAutocomplete = (data: GetApiSearchListingAutocompleteData): CancelablePromise<GetApiSearchListingAutocompleteResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/search/listing-autocomplete',
        query: {
            query: data.query
        }
    });
};